<div class="item">
    <h3 class="h5">{{item?.name}}</h3>
    <div class="bold">Category: {{item?.category}}</div>
    <div class="last-edited">
        <span>{{item?.lastUpdatedBy }}</span>
        <span>{{item?.lastUpdatedDate | date}}</span>
    </div>
</div>